module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/5-6751d271aa9c49d64cec0ccf4158f747.jpg";